/*
  Which package a visitor lands on.

  The product template always opens on its first package card. Traffic should
  land on the 2-device package instead, so the map below names the package for
  each product by the number printed on its card - not by variant id, so it
  survives price and variant changes.

  A visitor who arrived with a variant already in the address is left alone:
  that is a shared link, a return from checkout, or a deliberate choice.

  This runs before the product script, so the page opens on the right package
  rather than switching to it a moment later. The click at the end is only a
  fallback for the case where the template ignores the address.
*/
(function () {
  var DEFAULT_PACK = {
    'ערכת-מפיץ-ריח-מרגיע-לכלבים': '2'
  };

  /* Landing pages that embed the same product section (/pages/...) open on the
     same package as the product page. */
  var DEFAULT_PAGE_PACK = '2';

  var wanted = null;
  var hadVariantInUrl = window.location.search.indexOf('variant=') > -1;

  function wantedPack() {
    if (wanted !== null) return wanted;
    wanted = '';
    var path = '';
    try {
      path = decodeURIComponent(window.location.pathname);
    } catch (e) {
      return wanted;
    }
    if (path.indexOf('/pages/') > -1) {
      wanted = DEFAULT_PAGE_PACK;
      return wanted;
    }
    var handle = path.split('/products/')[1] || '';
    handle = handle.split('/')[0].split('?')[0];
    wanted = DEFAULT_PACK[handle] || '';
    return wanted;
  }

  function packInput(label) {
    var inputs = document.querySelectorAll('input[name^="dlp-bundle"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].dataset.qtyLabel === label) return inputs[i];
    }
    return null;
  }

  function setAddress() {
    if (hadVariantInUrl) return;
    var label = wantedPack();
    if (!label) return;
    var input = packInput(label);
    if (!input || !input.value || input.dataset.available === 'false') return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url.href);
    } catch (e) {}
  }

  function clickIfNeeded() {
    if (hadVariantInUrl) return;
    var label = wantedPack();
    if (!label) return;
    var input = packInput(label);
    if (!input || input.checked || input.dataset.available === 'false') return;
    input.click();
  }

  setAddress();
  document.addEventListener('DOMContentLoaded', setAddress);

  var tries = 0;
  var timer = setInterval(function () {
    clickIfNeeded();
    var label = wantedPack();
    var input = label ? packInput(label) : null;
    if (!label || (input && input.checked) || ++tries > 20) clearInterval(timer);
  }, 250);
})();
